<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '80%' : '55%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="payments.headers"
                :items="payments.lstPayments"
                :items-per-page="payments.itemsPerPage"
                no-data-text="Nenhum pagamento encontrado"
                @click:row="openPayment"
                class="card-scroll"
                :page="payments.page"
                :items-length="payments.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="payments.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewPayment()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Payments/>
</template>

<script>
import { useDisplay } from 'vuetify'
import Payments from '../Payments.vue';

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        Payments
    },
    computed: {
        payments: {
            get() {
                return this.$store.state.payments
            },
        },
    },
    methods: {
        async openPayment(event, row) {
            this.$router.push({
                name: 'EditPayment',
                params: {
                    paymentId: row.item.paymentId
                }
            })
        },
        openNewPayment() {
            this.$router.push({ name: 'NewPayment' })
        },
        async search() {
            await this.$store.dispatch("payments/search", { limit: this.payments.itemsPerPage, reset: true })
        },
        async updateOptions(options) {
            this.$store.commit('payments/setPage', options.page)

            await this.$store.dispatch("payments/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
    },
    watch: {
        '$store.state.payments.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('payments/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>